module.exports = __webpack_public_path__ + "static/media/groceries.9687729a.svg";